// extracted by mini-css-extract-plugin
export var blink = "_ai-2";
export var cursor = "_ai-1";
export var reactMarkdown = "_ai-3";
export var streamingText = "_ai-0";